var exports = {
  "kL": "xa15a2ab7--ab9387--container",
  "ai": "xa15a2ab7--ab9387--number",
  "Qq": "xa15a2ab7--ab9387--text",
};

module.exports = exports;
